import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view04ImageOptions } from './views/exterior_view04'

class XC38BathingPlatform extends Component {

    render() {
        let imageOptions = exterior_view04ImageOptions;

        let image = <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='Transom door / Bathing Platform - Foldable with electric hoisting system. The bathing platform of an Xc 38 is standard and fitted with genuine teak – optional material is flexiteek.' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38BathingPlatform);


// WEBPACK FOOTER //
// ./src/XC38/XC38BathingPlatform.js